module.exports = __webpack_public_path__ + "static/img/lotte-aa.9ecc9b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lotte-aa.jpg
// module id = BrmI
// module chunks = 0